"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesWatchers = exports.coreInitiativesReducers = void 0;
const xuder_1 = require("@sonar-software/xuder");
const redux_1 = require("redux");
const delete_1 = require("./delete.js");
const get_1 = require("./get.js");
const _idMap_1 = require("./_idMap/index.js");
const patch_1 = require("./patch.js");
const post_1 = require("./post.js");
const bulk_1 = require("./bulk/index.js");
const _id_1 = require("./_id/index.js");
const comments_1 = require("./comments/index.js");
const export_1 = require("./export/index.js");
const files_1 = require("./files/index.js");
const links_1 = require("./links/index.js");
const sonar_objects_1 = require("./sonar-objects/index.js");
const statuses_1 = require("./statuses/index.js");
const summary_1 = require("./summary/index.js");
const tags_1 = require("./tags/index.js");
const tasks_1 = require("./tasks/index.js");
exports.coreInitiativesReducers = (0, redux_1.combineReducers)({
    bulk: bulk_1.coreInitiativesBulkReducers,
    byId: _id_1.coreInitiativesByIdReducers,
    byIdMap: _idMap_1.coreInitiativesIdMapReducers,
    comments: comments_1.coreInitiativesCommentsReducers,
    delete: delete_1.coreInitiativesDeleteAsyncSlice.asyncReducers,
    export: export_1.coreInitiativesExportReducers,
    files: files_1.coreInitiativesFilesReducers,
    get: get_1.coreInitiativesGetAsyncSlice.asyncReducers,
    links: links_1.coreInitiativesLinksReducers,
    patch: patch_1.coreInitiativesPatchAsyncSlice.asyncReducers,
    post: post_1.coreInitiativesPostAsyncSlice.asyncReducers,
    sonarObjects: sonar_objects_1.coreInitiativesSonarObjectsReducers,
    statuses: statuses_1.coreInitiativesStatusesReducers,
    summary: summary_1.coreInitiativesSummaryReducers,
    tags: tags_1.coreInitiativesTagsReducers,
    tasks: tasks_1.coreInitiativesTasksReducers
});
exports.coreInitiativesWatchers = (0, xuder_1.combineAllWatchers)([
    bulk_1.coreInitiativesBulkWatchers,
    _id_1.coreInitiativesByIdWatchers,
    comments_1.coreInitiativesCommentsWatchers,
    delete_1.coreInitiativesDeleteAsyncSlice.asyncWatchers,
    export_1.coreInitiativesExportWatchers,
    files_1.coreInitiativesFilesWatchers,
    get_1.coreInitiativesGetAsyncSlice.asyncWatchers,
    links_1.coreInitiativesLinksWatchers,
    patch_1.coreInitiativesPatchAsyncSlice.asyncWatchers,
    post_1.coreInitiativesPostAsyncSlice.asyncWatchers,
    sonar_objects_1.coreInitiativesSonarObjectsWatchers,
    statuses_1.coreInitiativesStatusesWatches,
    summary_1.coreInitiativesSummaryWatchers,
    tags_1.coreInitiativesTagsWatchers,
    tasks_1.coreInitiativesTasksWatchers
]);
//# sourceMappingURL=index.js.map